import { Icon, Point } from 'leaflet';

import deviceLosingDataIcon from './device-losing-data.svg';

export const DeviceLosingData = new Icon({
  iconUrl: deviceLosingDataIcon,
  iconSize: new Point(35, 35),
  iconAnchor: [18, 18],
  tooltipAnchor: [0, -20],
  popupAnchor: [0, -10],
});
